<template>
  <div>
    <div class="news" v-if="dataList && dataList.length>0">
      <div class="item" v-for="item in dataList" :key="item.wid">
        <div class="flex-center-between">
          <div class="flex-col-center">
            <div class="dots"></div>
            <div class="title" :title="item.TITLE" @click="openDetail(item.WID)">{{ item.TITLE }}</div>
          </div>
          <p class="time" :title="item.CREATE_TIME.slice(0,10)">{{ item.CREATE_TIME.slice(0,10) }}</p>
          <p
            class="time"
            style="margin-left: 1rem;"
            :title="item.READNUM"
          >浏览量：{{ item.READNUM ? item.READNUM: 0 }}</p>
        </div>

        <!-- <div class="subtitle" :title="item.CONTENTNOHTML">{{ item.CONTENTNOHTML }}</div>  -->

        <!-- <div class="answer">
          <div class="btn">回复</div>
          <div class="content" :title="item.REPLY_CONTENTNOHTML">{{ item.REPLY_CONTENTNOHTML }}</div>
        </div>-->
      </div>
    </div>

    <el-pagination
      v-if="dataList && dataList.length>0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      layout="prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <div class="empty" v-if="dataList && dataList.length==0">
      <img src="../../static/assets/empty.png" alt />
      <p>暂无数据</p>
    </div>
  </div>
</template>
<script>
import * as utils from "../utils";
import api from "../api";
export default {
  data() {
    return {
      dataList: [],
      currentPage: 1,
      pageSize: 10,
      pageNum: 1,
      total: 100
    };
  },
  created() {
    this.getData();
    this.getLetterCount();
  },
  methods: {
    getData() {
      utils.Get(api.getSelLetterList, {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }).then((res) => {
        let resp = JSON.parse(res.data);
        if (resp.success) {
          // let datas = resp.datas && resp.datas.slice(0, 10);
          let datas = resp.datas;
          this.dataList = datas;
        } else {
          this.dataList = [];
        }
        // console.log(this.dataList)

      });
    },
    openDetail(id) {
      window.open("/oa/sys/newoadxzxx/viewDocument.do?WID=" + id)
    },

    handleSizeChange(data) {
      console.log(data)
    },

    handleCurrentChange(data) {
      this.pageNum = data;
      this.getData();
     },

    getLetterCount() {
      utils.Get(api.getLetterCount).then(res => {
        let resp = JSON.parse(res.data)
        this.total = Number(resp.datas[0].allLetterCount) || 0;
      });
    },
  },
};
</script>
<style scoped>
.news {
  width: 100%;
  height: 31.5rem;
  overflow: auto;
}

.flex-center-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-col-center {
  display: flex;
  align-items: center;
}

.dots {
  width: 0.38rem;
  height: 0.38rem;
  border-radius: 50%;
  background: #395eaa;
  margin-right: 0.69rem;
}

.title {
  font-size: 1rem;
  color: #141414;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 23rem;
  cursor: pointer;
}

.title:hover {
  color: #395eaa;
}

.time {
  font-size: 0.75rem;
  color: #8c8c8c;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subtitle {
  font-size: 0.88rem;
  color: #595959;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0.5rem 0 0.63rem;
}

.answer {
  width: calc(100% - 1.26rem);
  height: 3.06rem;
  background-image: linear-gradient(
    253deg,
    rgba(233, 240, 255, 0.6) 1%,
    rgba(233, 240, 255, 0.6) 37%
  );
  border-radius: 0.25rem;
  font-size: 0.88rem;
  color: #595959;
  display: flex;
  align-items: center;
  padding: 0 0.63rem;
}

.content {
  width: 33rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 0.5rem;
}

.btn {
  border: 0.06rem solid #3c5ca1;
  border-radius: 0.13rem;
  width: 2.38rem;
  height: 1.31rem;
  text-align: center;
  line-height: 1.31rem;
  font-size: 0.75rem;
  color: #395eaa;
  letter-spacing: 0.05rem;
}

.item {
  padding-bottom: 0.88rem;
  box-shadow: inset 0 -0.06rem 0 0 #f0f0f0;
  padding-top: 0.88rem;
}

.empty {
  text-align: center;
}

.empty img {
  width: 50%;
  margin-top: 10rem;
}

.empty p {
  font-size: 1rem;
  color: #595959;
  font-weight: bold;
  margin-top: 1rem;
}

.el-pagination {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// news.vue?7a71dabe